import { defineMessages } from 'react-intl';

export default defineMessages({
  REMOVE_FILE: {
    defaultMessage: 'Supprimer le fichier',
  },

  DOWNLOAD_FILE: {
    defaultMessage: 'Télécharger le fichier',
  },
} as const);
